import classNames from 'classnames';
import { GatsbyImage } from "gatsby-plugin-image";
import React from 'react';

import AnimateReveal from '../AnimateReveal/AnimateReveal';
import Button, { themes, sizes } from '../UI/Button/Button';
import Emphasise from '../UI/Emphasise/Emphasise';
import HtmlContent from '../UI/HtmlContent/HtmlContent';
import { motion } from '../UI/framer-motion-custom';
import * as styles from './PromotionFeatured.module.scss';

const PromotionFeatured = ({ title, link, description, image }) => {
  const classname = classNames(styles.promotion);

  return (
    <section className={classname}>
      <div className={styles.inner}>
        <GatsbyImage
          image={image?.localFile?.large?.gatsbyImageData}
          className={styles.image} />
        <AnimateReveal className={styles.body} staggerChildren={true}>
          <motion.h2 className={styles.title}>
            <Emphasise>{title}</Emphasise>
          </motion.h2>
          <HtmlContent
            as={motion.div}
            content={description}
          />
          <motion.div>
            <Button
              theme={themes.LINK}
              isReverse
              size={sizes.LARGE}
              to={link.url}
            >
              {link.title}
            </Button>
          </motion.div>
        </AnimateReveal>
      </div>
    </section>
  );
};

export { PromotionFeatured as default };
